module.exports = __webpack_public_path__ + "img/firefox_step_1.41919774.jpg";